module.exports = __webpack_public_path__ + "media/images/arrow-right-87a94936fdd993b5f5da41460fbb6408.svg";